export default  {
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "World Rugby | Sports for Nature",
  "shortTitle": "",
  "description": "",
  "width": 1240,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  // "basePath": "",
  "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://touchline-rugby-for-nature.s3-website.eu-west-2.amazonaws.com/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true,
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true,
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true,
  },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 1-title" style="top: 5px;left: 99px;" src="/static/_content/1-title-1.png" />
        <img class="abs halfScaleC 1-logo" style="top: 652px;left: 1098px;" src="/static/_content/1-logo-1.png" />

        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/1-img-1.png" style="top:444px;left:-184px;" />
      
        <div class="abs contentLinkNone" style="top:454px;left:66px;width:645px;height: 35px;" onclick="showOnePopOne()"></div>

        <div id="1-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="halfScale" src="/static/_content/1-pop-1.png" style="top:508px;left:122px;" />
          <div class="abs contentLinkNone close-pop-up" style="top:506px;left:494px;width:39px;height:40px;" onclick="closeOnePopOne()"></div>
        </div>

        <div class="addContentLink" style="top:344px;left:267px;width:246px;height:19px">
          <a href="https://www.iucn.org/our-work/topic/tourism-and-sport/sports-nature" target="_blank"></a>
        </div>
        `,
        "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-title"), 1, {x:30,opacity:0}, {x:0, opacity:1, ease: Power2.easeNone}, 0.3, 1)
          .fromTo(cOf("1-logo"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut, onComplete: addContentLinks}, 1.3)
        }

        function showOnePopOne(){
          showOverlay('1-pop-1');
          OnePopOne = new TimelineMax();
        }
        
        function closeOnePopOne(){
          OnePopOne.stop();
          hideOverlay('1-pop-1');
        }

        function onPageLeave() {
          pg1Anim.stop()
          removeContentLinks()
          hideOverlay('1-pop-1');
        }
      `,
      "searchText": "JOIN THE RUGBY FOR NATURE SQUAD Wallabies, jaguars and toucans compete against springboks, eagles and cockerels. Silver ferns, maple leaves and cherry blossoms thrive alongside thistles, roses and shamrocks. Wherever we look in rugby, nature is deeply entrenched in our game. It’s the emblem on our jerseys, building a connection rooted in the DNA of the team and their supporters. But nature and biodiversity are increasingly under threat and without it, there can be no rugby – the grass on the pitches, the clean air and healthy food necessary to power performance are all under-written by nature. As a signatory to the Sports for Nature Framework, and building on the positive impact of Rugby World Cup 2023, World Rugby has developed a game plan for nature so that the global rugby family can play their part to deliver for nature and channel those core values such as passion, solidarity and respect which help define our sport.  Make it a 10-point game for rugby and nature!"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/2-img-1.png" style="top:90px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:150px;left:66px;width:535px;height: 140px;" onclick="twoContentsBub(1)"></div>

        <img class="cont-item cont-item-1-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/2-pop-1.png">



        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/2-img-2.png" style="top:230px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:289px;left:66px;width:535px;height: 140px;" onclick="twoContentsBub(2)"></div>

        <img class="cont-item cont-item-2-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/2-pop-2.png">



        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/2-img-3.png" style="top:368px;left:-175px;" />
    
        <div class="abs contentLinkNone" style="top:429px;left:66px;width:535px;height: 140px;" onclick="twoContentsBub(3)"></div>

        <img class="cont-item cont-item-3-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/2-pop-3.png">



        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/2-img-4.png" style="top:505px;left:-175px;" />
  
        <div class="abs contentLinkNone" style="top:565px;left:66px;width:535px;height: 140px;" onclick="twoContentsBub(4)"></div>

        <img class="cont-item cont-item-4-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/2-pop-4.png">

        
          
        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/2-img-5.png" style="top:643px;left:-175px;" />

        <div class="abs contentLinkNone" style="top:705px;left:66px;width:535px;height: 140px;" onclick="twoContentsBub(5)"></div>

        <img class="cont-item cont-item-5-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/2-pop-5.png">


        <div class="abs contentLinkNone close-pop-up" style="top:139px;left:989px;width:43px;height: 40px;" onclick="twoContentsBubClose()"></div>
        `,
        "script": `
          function twoContentsBub(index){
            for(var i=0; i <= 5; i++){
              if(i == index){
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 1;
                },0);
              }else{
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                    c.style.opacity = 0;
                  },0);
              }
            }
          }
          function twoContentsBubClose(){
            for(var i=0; i <= 5; i++){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 0;
                },0);
            }
          }

          function onPageLeave() {
            twoContentsBubClose()
          }
        `,
      "searchText": "PHASE ONE: THE TRY Get over the goal line - five actions that everyone can drive for to get their first five points on the board and set up for success!  1 2 3 4 5  Build your “Nature Squad” Understand your starting position Draft and share your game plan Be mindful of nature on and off the field of play Give nature a home"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/3-img-1.png" style="top:90px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:150px;left:66px;width:535px;height: 140px;" onclick="threeContentsBub(1)"></div>

        <img class="cont-item cont-item-1-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/3-pop-1.png">


        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/3-img-2.png" style="top:230px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:289px;left:66px;width:535px;height: 140px;" onclick="threeContentsBub(2)"></div>

        <img class="cont-item cont-item-2-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/3-pop-2.png">


        <div class="abs contentLinkNone close-pop-up" style="top:139px;left:989px;width:43px;height: 40px;" onclick="threeContentsBubClose()"></div>
        `,
        "script": `
          function threeContentsBub(index){
            for(var i=0; i <= 2; i++){
              if(i == index){
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 1;
                },0);
              }else{
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                    c.style.opacity = 0;
                  },0);
              }
            }
          }
          function threeContentsBubClose(){
            for(var i=0; i <= 2; i++){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 0;
                },0);
            }
          }

          function onPageLeave() {
            threeContentsBubClose()
          }
        `,
      "searchText": "PHASE TWO: THE CONVERSION With the first five points on the board, it’s time to aim for the posts and extend your lead with an extra two points from two actions focusing on food and sourcing.  6 7  Make healthy food choices for mind, body and nature Get suppliers and partners onside"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/4-img-1.png" style="top:90px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:150px;left:66px;width:535px;height: 140px;" onclick="fourContentsBub(1)"></div>

        <img class="cont-item cont-item-1-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/4-pop-1.png">


        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/4-img-2.png" style="top:230px;left:-175px;" />
      
        <div class="abs contentLinkNone" style="top:289px;left:66px;width:535px;height: 140px;" onclick="fourContentsBub(2)"></div>

        <img class="cont-item cont-item-2-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/4-pop-2.png">


        <img class="halfScaleC halfpulsetwo animatedpulse" src="/static/_content/4-img-3.png" style="top:368px;left:-175px;" />
    
        <div class="abs contentLinkNone" style="top:429px;left:66px;width:535px;height: 140px;" onclick="fourContentsBub(3)"></div>

        <img class="cont-item cont-item-3-link halfScale" style="top:140px; left: 619px;opacity:0;"
          src="/static/_content/4-pop-3.png">


        <div class="abs contentLinkNone close-pop-up" style="top:139px;left:989px;width:43px;height: 40px;" onclick="fourContentsBubClose()"></div>
        `,
        "script": `
          function fourContentsBub(index){
            for(var i=0; i <= 3; i++){
              if(i == index){
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 1;
                },0);
              }else{
                [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                    c.style.opacity = 0;
                  },0);
              }
            }
          }
          function fourContentsBubClose(){
            for(var i=0; i <= 3; i++){
              [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                  c.style.opacity = 0;
                },0);
            }
          }

          function onPageLeave() {
            fourContentsBubClose()
          }
        `,
      "searchText": "PHASE THREE: THE DROP GOAL Maximum effort required but with three final points up for grabs, knock it over the bar and out of the park to make it a 10-point game and secure the win for nature!  8 9 10  Make some noise to rally the crowd Lift the trophy together Raise the bar"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
        <img class="halfScaleC" src="/static/_content/5-img-1.png" style="top:90px;left:-194px;" />

        <img class="halfScaleC" src="/static/_content/5-img-2.png" style="top:226px;left:-194px;" />

        <img class="halfScaleC" src="/static/_content/5-img-3.png" style="top:364px;left:-194px;" />
    
        <img class="halfScaleC" src="/static/_content/5-img-4.png" style="top:503px;left:-194px;" />

        <img class="halfScaleC" src="/static/_content/5-img-5.png" style="top:643px;left:-194px;" />
        `,
        "script": `
      `,
      "searchText": "FIVE R’S TO SUPPORT RUGBY FOR NATURE: Refrain from doing any harm to nature Recognise your impacts and scope of influence Reduce waste (especially plastics) and consumption that can negatively impact nature Restore spaces and places for nature, including habitats for plants and wildlife, to thrive and survive Report and share your ambition, objectives, activities, successes and challenges"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <div class="addContentLink" style="top:461px;left:179px;width:221px;height:24px">
          <a href="mailto:SportsforNature@iucn.org"></a>
        </div>
        <div class="addContentLink" style="top:490px;left:202px;width:351px;height:24px">
          <a href="https://www.linkedin.com/company/sports4nature" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:519px;left:192px;width:270px;height:24px">
          <a href="https://www.twitter.com/Sports4Nature" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:551px;left:219px;width:310px;height:24px">
          <a href="https://www.instagram.com/sportsfornature/" target="_blank"></a>
        </div>

        <div class="addContentLink" style="top:634px;left:242px;width:261px;height:24px">
          <a href="https://www.world.rugby/sustainability" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:666px;left:178px;width:509px;height:24px">
          <a href="https://www.iucn.org/our-work/topic/tourism-and-sport/sports-nature" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:695px;left:165px;width:386px;height:24px">
          <a href="https://www.olympics.com/ioc/sustainability/essentials" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:726px;left:375px;width:124px;height:24px">
          <a href="https://www.unep.org" target="_blank"></a>
        </div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "READY TO JOIN THE SPORT FOR NATURE FRAMEWORK? World Rugby is a proud signatory to the Sports for Nature Framework, a joint initiative of the International Union for Conservation of Nature, International Olympic Committee, United Nations Environment Programme, Secretariat of the Convention on Biological Diversity, and Sails of Change. The Sports for Nature Framework aims to deliver transformative action for nature across sports, by 2030 and beyond, enabling sports to champion nature and contribute to its protection and restoration. It provides a game plan for sports — at all levels — to accelerate and inspire others to take action for nature. Learn how your organisation can become a signatory and support action for nature! Email: SportsforNature@iucn.org LinkedIn: www.linkedin.com/company/sports4nature Twitter: www.twitter.com/Sports4Nature Instagram: www.instagram.com/sportsfornature/ For more information and resources, visit: World Rugby: www.world.rugby/sustainability IUCN: www.iucn.org/our-work/topic/tourism-and-sport/sports-nature IOC: www.olympics.com/ioc/sustainability/essentials UN Environment Programme: www.unep.org"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js